/**
 * Redux reducers are defined in this folder
 * Export them from your index file
 *
 * DO NOT call combineReducers here. That is done for you
 * in store/index.js
 *
 *
 * import app from './app';
 *
 * export default {
 *  app,
 * };
 */

import app from './app';
import user from './user';
import doctorProfile from './doctorProfile';
import info from './info';
import notifications from './notifications';
import pendingRequests from './pending-requests';
import pendingOnboardings from './pendingOnboardings';
import comments from './comments';

export default {
  app,
  user,
  doctorProfile,
  info,
  notifications,
  pendingRequests,
  pendingOnboardings,
  comments
};
